module.exports = __webpack_public_path__ + "img/sunat--icon.79d640ad.svg";